export default __webpack_public_path__ + "static/media/Honored Gloves of the Plains.0d05667b.jpg";